import type { api } from "@healthos/schemas";
import { NumberField } from "./manual-signal-log-fields";
import type { ManualLogForm } from "./manual-signal-log-model";

type FormPatch = Partial<ManualLogForm>;

export function VitalsFields({
  form,
  onPatch,
}: {
  form: ManualLogForm;
  onPatch: (patch: FormPatch) => void;
}) {
  return <VitalReadingField metric={form.vitalsMetric} form={form} onPatch={onPatch} />;
}

function VitalReadingField({
  metric,
  form,
  onPatch,
}: {
  metric: api.ManualVitalsMetric;
  form: ManualLogForm;
  onPatch: (patch: FormPatch) => void;
}) {
  switch (metric) {
    case "weight":
      return (
        <NumberField
          label="Weight"
          value={form.kg}
          onChange={(kg) => onPatch({ kg })}
          suffix="kg"
          min="0.1"
          step="0.1"
        />
      );
    case "blood_pressure":
      return (
        <div className="grid gap-5 sm:grid-cols-2">
          <NumberField
            label="Systolic"
            value={form.systolic}
            onChange={(systolic) => onPatch({ systolic })}
            suffix="mmHg"
            min="1"
          />
          <NumberField
            label="Diastolic"
            value={form.diastolic}
            onChange={(diastolic) => onPatch({ diastolic })}
            suffix="mmHg"
            min="1"
          />
        </div>
      );
    case "glucose":
      return (
        <NumberField
          label="Glucose"
          value={form.glucoseMgDl}
          onChange={(glucoseMgDl) => onPatch({ glucoseMgDl })}
          suffix="mg/dL"
          min="1"
        />
      );
    case "resting_hr":
      return (
        <NumberField
          label="Resting heart rate"
          value={form.bpm}
          onChange={(bpm) => onPatch({ bpm })}
          suffix="bpm"
          min="1"
        />
      );
    case "hrv":
      return (
        <NumberField
          label="HRV"
          value={form.hrvMs}
          onChange={(hrvMs) => onPatch({ hrvMs })}
          suffix="ms"
          min="1"
        />
      );
    case "temperature":
      return (
        <NumberField
          label="Temperature"
          value={form.temperatureC}
          onChange={(temperatureC) => onPatch({ temperatureC })}
          suffix="C"
          min="25"
          max="45"
          step="0.1"
        />
      );
    case "hba1c":
      return (
        <NumberField
          label="HbA1c"
          value={form.hba1cPercent}
          onChange={(hba1cPercent) => onPatch({ hba1cPercent })}
          suffix="%"
          min="3"
          max="20"
          step="0.1"
        />
      );
  }
}
